import React, {ReactNode} from 'react'

import {Mode, ProfileMenuItem, SidebarMenuItems} from '../components/layout/types'

type DashboardProviderProps = {
  currentMode: Mode;
  organizationName: string;
  menuItems: SidebarMenuItems[];
  profileMenuItems?: ProfileMenuItem[];
  children: ReactNode;
  onProfileMenuItemClick: () => void;
  isAuthenticated?: boolean;
}

interface DashboardContextInterface {
  currentMode: Mode;
  organizationName: string;
  menuItems: SidebarMenuItems[];
  profileMenuItems?: ProfileMenuItem[];
  handleProfileMenuItemClick: () => void;
  isAuthenticated?: boolean;
}

const DashboardContextDefaultValue:DashboardContextInterface = {
  currentMode: '',
  organizationName: '',
  menuItems: [],
  profileMenuItems: [],
  handleProfileMenuItemClick: () => {},
  isAuthenticated: true
}

const DashboardContext = React.createContext<DashboardContextInterface>(
  DashboardContextDefaultValue
)

function useDashboard() {
  const context = React.useContext(DashboardContext)
  if (context === undefined) {
    throw new Error('useDashboard must be used within a DashboardProvider')
  }
  return context
}

const DashboardProvider = ({currentMode, organizationName, menuItems, onProfileMenuItemClick, profileMenuItems, children, isAuthenticated}: DashboardProviderProps) => {
  const handleProfileMenuItemClick = () => onProfileMenuItemClick()

  return (
    <DashboardContext.Provider
      value={{
        currentMode,
        organizationName,
        menuItems,
        profileMenuItems,
        handleProfileMenuItemClick,
        isAuthenticated
      }}
    >
      {children}
    </DashboardContext.Provider>
  )
}

export {DashboardProvider, useDashboard}
